module.exports = "<select class=\"form-control\" ng-model=\"model[options.key]\" ng-options=\"option.name for option in to.options track by option.id\">\r\n    <option ng-hide=\"to.nullable\" value=\"\">{{to.nullableDisplay}}</option></select>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/types/dropdown.html
// module id = 619
// module chunks = 1